/**
 * * end of cart upsell block part
 */
document.addEventListener("DOMContentLoaded", function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cartTotalEl = document.querySelector(".gb-totals-total-value");
  var cart_total = cartTotalEl ? (cartTotalEl.textContent || "").trim() : "";
  if (amountFreeProduct > 0 && show_progress_bar) {
    const hasPremiumKit = document.querySelector(".premium-attachment-kit") !== null;
    if (hasPremiumKit) {
      console.log("Premium kit detected - skipping auto free gift trigger");
      return;
    }
    setTimeout(function () {
      var el = document.querySelector(".gb-totals-total-value");
      var cart_total = el ? (el.textContent || "").trim() : "";
      if (cart_total >= amountFreeProduct) {
        if (document.querySelector(".cart-item.gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          var trigger = document.querySelector(".gb-free-product-trigger");
          if (trigger) trigger.click();
        }
      } else {
        console.log("Removing free product - under threshold");
        var removeBtn = document.querySelector(".gb-remove-product");
        if (removeBtn) removeBtn.click();
      }
    }, 3000);

    document.body.addEventListener("click", function (e) {
      if (!e.target.closest(".gb-sumbit-free")) return;
      setTimeout(function () {
        var el = document.querySelector(".gb-totals-total-value");
        var cart_total = el ? (el.textContent || "").trim() : "";
        if (cart_total >= amountFreeProduct) {
          if (!document.querySelector(".cart-item.gb-find-remove-product")) {
            var trigger = document.querySelector(".gb-free-product-trigger");
            if (trigger) trigger.click();
          }
        } else {
          var removeBtn = document.querySelector(".gb-remove-product");
          if (removeBtn) removeBtn.click();
        }
      }, 3000);
    });
  }

  document.body.addEventListener("click", async function (e) {
    var label = e.target.closest && e.target.closest(".gb-shipping-protection-button label.switch");
    if (!label) return;
    if (e.target.tagName === "INPUT") return;
    const curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    const curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    const spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    const checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    const wasChecked = curElem && curElem.classList.contains("checked");

    if (!wasChecked) {
      if (!curElem || !curInputElem || !spinAnim || !checkElem) return;
      if (spinAnim.style.display === "block" || curInputElem.checked) return;
      const form = document.querySelector("form.shipping-protection-form");

      const formData = new FormData(form);
      if (!formData.get("id")) {
        console.error(
          "There is no shipping protection product selected. Please select the shipping product in the global theme settings",
        );
        return;
      }

      spinAnim.style.display = "block";

      try {
        const response = await fetch(routes.cart_add_url, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (response.ok) {
          spinAnim.style.display = "none";

          checkElem.style.display = "block";
        }
      } catch (err) {
        console.error("error at shipping protection form submission", err);
      }
      fetch(routes.cart_url + "?view=drawer")
        .then((response) => response.text())
        .then((html) => {
          const cartDrawer = document.querySelector("#CartDrawer");
          const parsedCartHtml = parser.parseFromString(html, "text/html");
          const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
          if (cartDrawer && newCartDrawer) {
            updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
              curElem.classList.remove("unchecked");
              curElem.classList.add("checked");
              curInputElem.checked = true;
            });
          }
        })
        .catch((_err) => {
          curElem.classList.remove("unchecked");
          curElem.classList.add("checked");
          curInputElem.checked = true;
        });
    } else {
      checkElem.style.display = "none";
      const cartDrawer = document.querySelector("#CartDrawer");
      const removeButton = cartDrawer.querySelector(`cart-remove-button[data-id="${shippingProductId}"]`);
      const shippingItemIndex = removeButton?.dataset.index;

      const removeCallback = () => {
        curElem.classList.remove("checked");
        curElem.classList.add("unchecked");
        curInputElem.checked = false;
      };

      const cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");

      if (removeButton && shippingItemIndex && cartItems?.updateQuantity) {
        const event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", removeCallback);
      } else {
        fetch(routes.cart_change_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ id: shippingProductId, quantity: 0 }),
        })
          .then(() => fetch(routes.cart_url + "?view=drawer"))
          .then((response) => response.text())
          .then((html) => {
            const cartDrawer = document.querySelector("#CartDrawer");
            const parsedCartHtml = parser.parseFromString(html, "text/html");
            const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, removeCallback);
            } else {
              removeCallback();
            }
          })
          .catch(() => {
            removeCallback();
          });
      }
    }
  });

  document.body.addEventListener("change", function (e) {
    var select = e.target.closest && e.target.closest(".gb-change-variant_id");
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var id_change = opt ? opt.getAttribute("data-variant-id") : null;
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    var block = select.closest(".gb-get-main-freq-pro");
    var input = block ? block.querySelector(".product-variant-id") : null;
    if (input) input.value = id_change;
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions: require id when in single-variant mode; skip when form has items[] (bundles / premium kit)
document.addEventListener("submit", function (e) {
  if (typeof Elixir_ProductFormExists !== 'function' || !Elixir_ProductFormExists()) return;
  if (typeof Elixir_GetProductForm !== 'function' || Elixir_GetProductForm() !== e.target) return;
  if (typeof Elixir_GetProductFormVariantId !== 'function') return;
  if (typeof Elixir_ProductFormHasItemsInputs === 'function' && Elixir_ProductFormHasItemsInputs()) return;
  const variantId = Elixir_GetProductFormVariantId();
  if (!variantId) {
    console.log("Preventing submission - missing id parameter (single-product form has no variant id)");
    e.preventDefault();
    if (window.ThemeEditorToast && typeof window.ThemeEditorToast.show === 'function') {
      window.ThemeEditorToast.show('Add to cart failed: missing variant ID on product form.', { type: 'error', duration: 5000 });
    }
    return false;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function handleCartQuantityChange(e) {
    var cartItem = e.target.closest(".cart-item");
    if (!cartItem) return;
    var trigger =
      e.target.closest(".quantity__button") ||
      e.target.closest(".quantity__input") ||
      (e.target.matches && e.target.matches(".quantity__input") ? e.target : null);
    if (!trigger) return;
    var quantityInputWrap = trigger.closest(".quantity-input");
    var qtyInput = quantityInputWrap ? quantityInputWrap.querySelector(".quantity__input") : null;
    var variantId = qtyInput ? qtyInput.getAttribute("data-quantity-variant-id") : null;
    var form = trigger.closest("form");
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput && variantId) {
      console.log("Adding missing ID input to cart form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = variantId;
      form.appendChild(newIdInput);
    } else if (idInput && variantId) {
      idInput.value = variantId;
    }
  }
  document.addEventListener("click", handleCartQuantityChange);
  document.addEventListener("change", handleCartQuantityChange);
  document.addEventListener("input", handleCartQuantityChange);

  var checkoutBtn = document.getElementById("CartDrawer-Checkout");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      var form = document.getElementById("CartDrawer-Form");
      if (!form) return;
      var cartItems = form.querySelectorAll(".cart-item");
      if (cartItems.length === 0) {
        console.log("No items in cart, preventing checkout");
        e.preventDefault();
        return false;
      }
      console.log("Cart checkout with", cartItems.length, "items");
    });
  }

  document.addEventListener("keydown", function (e) {
    var input =
      (e.target.matches && e.target.matches(".quantity__input")
        ? e.target
        : e.target.closest && e.target.closest(".quantity__input")) || null;
    if (!input) return;
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      input.blur();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    var btn =
      e.target.closest(".gbfrequently-bought-with-main-whole button") ||
      e.target.closest(".gbfrequently-bought-with-main-whole .gb-sumbit-free") ||
      e.target.closest(".gb-free-product-trigger") ||
      e.target.closest(".gb-product-shipping-protection-product-tirgger") ||
      e.target.closest(".gb-product-sticky-add-to-cart-form");
    if (!btn) return;
    var parentBlock = btn.closest(".gb-get-main-freq-pro") || btn.closest("form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }
    var productId = null;
    var idInput = parentBlock.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      productId = idInput.value;
    } else if (parentBlock.querySelector(".gb-change-variant_id")) {
      var select = parentBlock.querySelector(".gb-change-variant_id");
      var opt = select && select.options[select.selectedIndex];
      if (opt) {
        productId = opt.getAttribute("data-variant-id");
      }
    } else if (parentBlock.querySelector(".product-variant-id")) {
      var variantInput = parentBlock.querySelector(".product-variant-id");
      productId = variantInput ? variantInput.value : null;
    } else if (btn.getAttribute("data-variant-id")) {
      productId = btn.getAttribute("data-variant-id");
    }
    console.log("Frequently bought product add to cart - ID:", productId);
    if (btn.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }
    if (!idInput) {
      console.log("Adding missing ID input to frequently bought product form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = productId;
      parentBlock.appendChild(newIdInput);
    } else {
      idInput.value = productId;
    }
    var quantityInput = parentBlock.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      console.log("Adding default quantity input to frequently bought product form");
      var newQtyInput = document.createElement("input");
      newQtyInput.type = "hidden";
      newQtyInput.name = "quantity";
      newQtyInput.value = "1";
      parentBlock.appendChild(newQtyInput);
    } else if (!quantityInput.value || parseFloat(quantityInput.value, 10) < 1) {
      quantityInput.value = "1";
    }
  });
});

// Kaching showing Price(Compare Price) Text in ATC fix

const KachingApp = () => {
  const isProductPage = document.querySelector('.shopify-section.shop-product-section');
  if (!isProductPage) return;

  let buttonObserver = null;

  const createElement = (tag, cls, content) => {
    const el = document.createElement(tag);
    el.classList.add(...cls.split(' '));
    el.textContent = content;
    return el;
  };

  const updateAddToCartButton = (bundle) => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton || !bundle) return;

    const buttonTextEl = addToCartButton.querySelector('.button-text');
    if (!buttonTextEl) return;

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (bundlePriceEl) {
      const price = bundlePriceEl.textContent.trim();
      const comparePrice = bundleComparePriceEl ? bundleComparePriceEl.textContent.trim() : '';

      // Get the persistent text (e.g., "Buy Now")
      const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

      // Update button text with actual values
      if (comparePrice) {
        buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
      } else {
        buttonTextEl.innerHTML = `${persistentText} - ${price}`;
      }

      // Store current bundle reference for observer
      addToCartButton.dataset.currentBundlePrice = price;
      addToCartButton.dataset.currentBundleComparePrice = comparePrice || '';
    }
  };

  const forceUpdateButton = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    const buttonTextEl = addToCartButton?.querySelector('.button-text');
    
    if (!buttonTextEl) return;

    const price = addToCartButton.dataset.currentBundlePrice;
    const comparePrice = addToCartButton.dataset.currentBundleComparePrice;
    const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

    // Check if button shows placeholders
    if (buttonTextEl.textContent.includes('[price]') || buttonTextEl.textContent.includes('[comparePrice]')) {
      if (price) {
        if (comparePrice) {
          buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
        } else {
          buttonTextEl.innerHTML = `${persistentText} - ${price}`;
        }
      }
    }
  };

  const setupButtonObserver = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton) return;

    // Disconnect existing observer if any
    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    // Create new observer to watch for button text changes
    buttonObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Use setTimeout to let the other script finish, then override
          setTimeout(forceUpdateButton, 0);
        }
      });
    });

    // Observe the button and its children for any changes
    buttonObserver.observe(addToCartButton, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });
  };

  const updatePriceBlock = (bundle) => {
    const priceBlock = document.querySelector('.shop-product-price-container');
    if (!priceBlock || !bundle) return;

    const priceEl = priceBlock.querySelector('.shop-product-price-block');
    const comparePriceEl = priceBlock.querySelector('.shop-compare-price');

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (priceEl && bundlePriceEl) priceEl.textContent = bundlePriceEl.textContent;

    if (bundleComparePriceEl) {
      if (comparePriceEl) {
        comparePriceEl.textContent = bundleComparePriceEl.textContent;
      } else {
        priceBlock.appendChild(
          createElement('span', 'shop-compare-price', bundleComparePriceEl.textContent)
        );
      }
    }
  };

  const updateAllPrices = (bundle) => {
    updatePriceBlock(bundle);
    updateAddToCartButton(bundle);
    
    // Force update again after a short delay to override any competing scripts
    setTimeout(() => forceUpdateButton(), 50);
    setTimeout(() => forceUpdateButton(), 200);
  };

  const initApp = (app) => {
    const applyFirstCheckedBundle = () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      if (selectedBundle) {
        updateAllPrices(selectedBundle);
      }
    };

    const initAppFunctions = () => {
      const interval = setInterval(() => {
        const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
        if (selectedBundle) {
          clearInterval(interval);
          updateAllPrices(selectedBundle);
          setupButtonObserver();
        }
      }, 300);
    };

    app.addEventListener('change', () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      updateAllPrices(selectedBundle);
    });

    applyFirstCheckedBundle();
    initAppFunctions();
  };

  const interval = setInterval(() => {
    const app = document.querySelector('kaching-bundle');
    if (app) {
      clearInterval(interval);
      initApp(app);
    }
  }, 300);
};

window.addEventListener('DOMContentLoaded', KachingApp);

/* === TREDWLL — relance 4-pack dans le tiroir (généré) === */
/**
 * Aucun bloc d'Elixir ne sait faire ça : `cart_upsell` propose un AUTRE
 * produit, alors que notre offre est une QUANTITÉ du même produit. On pose
 * donc une ligne de relance maison juste au-dessus du bouton de commande.
 *
 * Ce qu'elle dit dépend de ce qu'il y a dans le panier, et c'est vrai dans les
 * trois cas parce que la remise automatique « BUY 2, GET 2 FREE » est active :
 *   1 paire  → 3 de plus pour le prix d'une
 *   2 paires → les 2 suivantes sont offertes
 *   3 paires → la 4ᵉ est offerte
 *   4 et +   → rien, on se tait.
 *
 * ⚠️ Si la remise automatique est supprimée, ces phrases deviennent fausses.
 * Elle porte le titre « TREDWLL · BUY 2 GET 2 FREE » dans l'admin.
 */
(function () {
  var HANDLE = "tredwll-work-socks";
  var CIBLE = 4;
  var enCours = false;

  var PHRASES = {
    1: ["3 more pairs for the price of one",
        "Make it a FULL ROTATION \u2014 4 pairs, one price."],
    2: ["Your next 2 pairs are free",
        "Make it a FULL ROTATION \u2014 same price, twice the rotation."],
    3: ["Your 4th pair is free",
        "One more pair completes the FULL ROTATION."]
  };

  function lignesProduit(panier) {
    return (panier.items || []).filter(function (i) { return i.handle === HANDLE; });
  }

  function retirer() {
    var vieux = document.querySelector(".tw-relance");
    if (vieux) vieux.remove();
  }

  function poser(panier) {
    retirer();
    var lignes = lignesProduit(panier);
    if (!lignes.length) return;

    var total = lignes.reduce(function (n, i) { return n + i.quantity; }, 0);
    if (total >= CIBLE) return;
    var phrase = PHRASES[total];
    if (!phrase) return;

    // Le pied du tiroir, juste au-dessus du bouton de commande.
    var ancre = document.querySelector("#CartDrawer .cart__ctas");
    if (!ancre) return;

    // On fait monter la ligne la plus fournie jusqu'à 4 paires au total :
    // une seule requête, et le choix de taille du client est conservé.
    var principale = lignes.slice().sort(function (a, b) {
      return b.quantity - a.quantity;
    })[0];
    var manque = CIBLE - total;

    var el = document.createElement("div");
    el.className = "tw-relance";
    el.innerHTML =
      '<div class="tw-relance__txt"><strong></strong><span></span></div>' +
      '<button type="button" class="tw-relance__btn">Make it 4</button>';
    el.querySelector("strong").textContent = phrase[0];
    el.querySelector("span").textContent = phrase[1];

    el.querySelector("button").addEventListener("click", function (ev) {
      var bouton = ev.currentTarget;
      if (enCours) return;
      enCours = true;
      bouton.disabled = true;
      bouton.textContent = "Adding\u2026";
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: principale.key,
          quantity: principale.quantity + manque
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          var tiroir = document.querySelector("cart-drawer");
          if (tiroir && typeof tiroir.refreshCartDrawer === "function") {
            return tiroir.refreshCartDrawer();
          }
          window.location.reload();
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { enCours = false; });
    });

    ancre.parentNode.insertBefore(el, ancre);
  }

  function rafraichir() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(poser)
      .catch(function () {});
  }

  // Le tiroir est re-rendu entièrement par la Section Rendering API à chaque
  // changement : notre bloc disparaît avec. On le repose à chaque re-rendu,
  // en groupant les mutations pour ne pas relancer dix requêtes d'affilée.
  var minuteur = null;
  function programmer() {
    clearTimeout(minuteur);
    minuteur = setTimeout(rafraichir, 120);
  }

  function observer() {
    var cible = document.querySelector("#CartDrawer");
    if (!cible) return false;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        // Une mutation causée par notre propre insertion ne doit pas relancer
        // le cycle, sinon l'observateur se déclenche lui-même sans fin.
        var m = mutations[i];
        var noeuds = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
        var siens = noeuds.some(function (n) {
          return n.nodeType === 1 && n.classList && n.classList.contains("tw-relance");
        });
        if (!siens) { programmer(); return; }
      }
    }).observe(cible, { childList: true, subtree: true });
    return true;
  }

  function demarrer() {
    if (!observer()) {
      // Le tiroir est posé par le layout : sur une page lente il peut ne pas
      // être là au DOMContentLoaded.
      var essais = 0;
      var t = setInterval(function () {
        if (observer() || ++essais > 40) clearInterval(t);
      }, 250);
    }
    rafraichir();
    document.addEventListener("cart:updated", programmer);
    document.addEventListener("cart:refresh", programmer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", demarrer);
  } else {
    demarrer();
  }
})();

/* ── La quantité du palier retenu, appliquée AU CHARGEMENT ──────────────────
 *
 * ⚠️ Le défaut le plus coûteux de l'audit du 06/08.
 *
 * `quantity_bundle` peint la carte retenue dès le rendu — FULL ROTATION porte
 * `data-selected="true"`, elle est anthracite, cerclée hi-viz, agrandie, et
 * annonce « 4 pairs for the price of 2 · $53.80 ». Mais il ne synchronise
 * `input[name=quantity]` QU'AU CLIC. Le formulaire reste donc à 1.
 *
 * Conséquence mesurée sur la page publique : un visiteur qui fait confiance à
 * la carte présélectionnée et appuie sur ADD TO CART repart avec UNE paire à
 * 26,90 au lieu de quatre à 53,80. C'est le chemin par défaut, donc le plus
 * fréquenté, et rien à l'écran ne le laisse deviner.
 *
 * On ne simule pas un clic : sur certains thèmes il rouvre un carrousel ou
 * déclenche un changement de variante. On écrit la valeur, puis on émet
 * `input` et `change` — c'est ce qu'écoute le formulaire.
 *
 * Le `MutationObserver` couvre le cas où le bloc arrive après nous (section
 * rechargée dans l'éditeur de thème, ou rendu différé).
 */
(function () {
  function synchroniser() {
    var carte = document.querySelector(".quantity-bundle-card[data-selected='true']");
    if (!carte) return;
    var q = parseInt(carte.getAttribute("data-quantity"), 10);
    if (!q || q < 1) return;
    var form = document.querySelector("form[action*='/cart/add']");
    if (!form) return;
    var champ = form.querySelector("input[name='quantity']");
    if (!champ || parseInt(champ.value, 10) === q) return;
    champ.value = String(q);
    champ.dispatchEvent(new Event("input", { bubbles: true }));
    champ.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function demarrerQte() {
    synchroniser();
    var hote = document.querySelector("[id*='buybox']") || document.body;
    new MutationObserver(synchroniser).observe(hote, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ["data-selected"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", demarrerQte);
  } else {
    demarrerQte();
  }

  /* ── La galerie produit, différée ─────────────────────────────────────────
     Le carrousel empile TOUTES ses diapositives dans le DOM et n'en montre
     qu'une. `loading="lazy"` n'y sert donc à rien : pour le navigateur, elles
     sont toutes dans la fenêtre, et il les télécharge toutes avant même que le
     client ait fait défiler. Sept grandes images, une seule regardée.

     On décroche donc `src` et `srcset` des diapositives non retenues, rangés
     dans des `data-*`, et on les repose :
       · dès qu'une diapositive devient active (attribut `class` observé) ;
       · sinon au premier geste du visiteur, ou au plus tard après `load` —
         c'est-à-dire une fois le LCP passé, ce qui est tout l'objet.
     La diapositive active n'est JAMAIS touchée : rien ne peut clignoter. */
  function differerGalerie() {
    var vues = document.querySelectorAll(".shop-image-zoom-wrapper");
    if (!vues.length) return;
    var dormantes = [];

    vues.forEach(function (v) {
      if (v.classList.contains("active")) return;
      var img = v.querySelector("img");
      if (!img || !img.getAttribute("src")) return;
      img.dataset.srcDiffere = img.getAttribute("src");
      if (img.getAttribute("srcset")) {
        img.dataset.srcsetDiffere = img.getAttribute("srcset");
        img.removeAttribute("srcset");
      }
      img.removeAttribute("src");
      dormantes.push(img);
    });
    if (!dormantes.length) return;

    function reveiller(img) {
      if (!img || !img.dataset.srcDiffere) return;
      if (img.dataset.srcsetDiffere) {
        img.setAttribute("srcset", img.dataset.srcsetDiffere);
        delete img.dataset.srcsetDiffere;
      }
      img.setAttribute("src", img.dataset.srcDiffere);
      delete img.dataset.srcDiffere;
    }
    function toutReveiller() {
      dormantes.forEach(reveiller);
      dormantes = [];
    }

    /* Une diapositive qui devient active doit être servie SUR-LE-CHAMP. */
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.target.classList && m.target.classList.contains("active")) {
            reveiller(m.target.querySelector("img"));
          }
        });
      });
      vues.forEach(function (v) {
        mo.observe(v, { attributes: true, attributeFilter: ["class"] });
      });
    }

    ["pointerdown", "keydown", "touchstart", "wheel"].forEach(function (e) {
      window.addEventListener(e, toutReveiller, { once: true, passive: true });
    });
    if (document.readyState === "complete") {
      setTimeout(toutReveiller, 400);
    } else {
      window.addEventListener("load", function () { setTimeout(toutReveiller, 400); });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", differerGalerie);
  } else {
    differerGalerie();
  }
})();
/* === fin relance 4-pack TREDWLL === */


/* ===== TREDWLL-PRESELECTION-BUNDLE =====
   Présélectionner l'offre du milieu du Variant Bundle (sa demande du 03/09).
   Le thème sélectionne toujours la carte 0 : `variant-selector.js` ne trouve aucune carte
   portant `.selected` et retombe sur `selectVariant(0)`.

   ON CLIQUE, on ne pose pas la classe : seul `selectVariant()` écrit `input[name="id"]` du
   formulaire. Poser `.selected` à la main donnerait une carte cochée et un panier qui facture
   une autre variante — le bug qu'on vient de réparer, en plus discret.

   Cible par TITRE, jamais par rang : si les paliers sont réordonnés, un index en dur
   présélectionnerait silencieusement le mauvais. Repli sur la carte médiane, avec un
   avertissement — un repli muet est ce qui rend ce genre de défaut invisible. */
(function () {
  var VOULU = '3 BARS';

  function preselectionner() {
    var cartes = document.querySelectorAll('.variant-product-card');
    if (!cartes.length) return false;

    var cible = null;
    for (var i = 0; i < cartes.length; i++) {
      if ((cartes[i].getAttribute('data-variant-title') || '').trim() === VOULU) {
        cible = cartes[i];
        break;
      }
    }
    if (!cible) {
      cible = cartes[Math.floor(cartes.length / 2)];
      console.warn('[TREDWLL] Palier "' + VOULU + '" introuvable — repli sur la carte du milieu (' +
                   (cible.getAttribute('data-variant-title') || '?') + '). Le titre du palier a changé ?');
    }
    if (cible.classList.contains('selected')) return true;   // déjà fait, on ne reclique pas
    cible.click();
    console.log('[TREDWLL] Offre présélectionnée :', cible.getAttribute('data-variant-title'));
    return true;
  }

  /* Les cartes arrivent après nous : `variant-selector.js` est en `defer` et s'initialise au
     DOMContentLoaded. On observe le DOM au lieu de parier sur un délai fixe, et on s'arrête
     dès que c'est fait — ou au bout de 10 s, pour ne pas laisser un observateur vivant. */
  function demarrer() {
    if (preselectionner()) return;
    var obs = new MutationObserver(function () {
      if (preselectionner()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
